<template>
  <!-- Left side column. contains the logo and sidebar -->
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <!-- <div class="user-panel">
        <div class="pull-left image">
          <img src="dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <p>Alexander Pierce</p> -->
      <!-- Status -->
      <!-- <a><i class="fa fa-circle text-success"></i> Online</a>
        </div>
      </div> -->

      <!-- search form (Optional) -->
      <!-- <form action="#" method="get" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search...">
          <span class="input-group-btn">
                <button type="submit" name="search" id="search-btn" class="btn btn-flat"><i class="fa fa-search"></i>
                </button>
              </span>
        </div>
      </form> -->
      <!-- /.search form -->

      <!-- Sidebar Menu -->
      <ul data-widget="tree" class="sidebar-menu">
        <va-slide-item
          v-for="(item, index) in sidebarMenuItems"
          :data="item"
          :key="index"
          :type="item.type"
          :isHeader="item.isHeader"
          :icon="item.icon"
          :name="$t(item.name)"
          :badge="item.badge"
          :items="item.items"
          :router="item.router"
          :link="item.link"
          :class="{ disabled: item.disabled }"
        >
        </va-slide-item>
      </ul>
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VASlideItem from "@/components/LTESlideItem";
import utils from '@/lib/utils';

export default {
  name: "lte-sidebar",
  props: {
    slideMenuItems: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      available_modules: []
    };
  },
  watch: {
    GET_AVAILABLE_MODULE_DATA: function() {
      this.available_modules = [];
      let modules = this.GET_AVAILABLE_MODULE_DATA;
      modules.forEach(module => {
        this.available_modules.push(module.sidebarname);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_AVAILABLE_MODULE_DATA",
      "GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA"
    ]),
    role: function() {
      return this.GET_ACCOUNT_DATA.group_id;
    },
    superAdmin: function() {
      return this.GET_ACCOUNT_DATA.id;
    },
    sidebarMenuItems: function() {
      this.getModuleConfigEnable()
      let privilege = this.GET_ACCOUNT_DATA.privilege_id;
      let user_id = this.GET_ACCOUNT_DATA.id;
      if (!privilege) {
        return;
      }
      let permittedSlideMenuItems = [];
      let permittedLargeItems = this.permittedLargeModules(privilege, user_id);
      let permittedMediumItems = this.permittedMediumModules(
        privilege,
        user_id
      );
      this.slideMenuItems.forEach(
        function(largeItem, index) {
          if ("meta" in largeItem) {
            // check allowed large item
            if (permittedLargeItems.indexOf(largeItem.meta.code) < 0) {
              return;
            }

            let middleItems = "items" in largeItem ? largeItem.items : [];
            //let middleItems = 'items' in largeItem ? largeItem.pop('items') : []
            let slideMiddleItems = [];
            if (middleItems.length > 0) {
              // check allowed medium item
              for (let index2 = 0; index2 < middleItems.length; index2++) {
                let middleItem = middleItems[index2];
                if ("meta" in middleItem) {
                  let middleItem_metacode = `${largeItem.meta.code}_${
                    middleItem.meta.code
                  }`;
                  if (permittedMediumItems.indexOf(middleItem_metacode) > -1) {
                    slideMiddleItems.push(middleItem);
                  }
                } else {
                  slideMiddleItems.push(middleItem);
                }
              }
            }
            largeItem.items = slideMiddleItems;
          }
          // no meta, default to add
          permittedSlideMenuItems.push(largeItem);
        }.bind(this)
      );
      return permittedSlideMenuItems;
    }
  },
  methods: {
    ...mapActions([
      "GET_AVAILABLE_MODULE"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    isAdmin: function() {
      return utils.isAdmin(this.GET_ACCOUNT_DATA)
    },
    is_check_has: function(module) {
      if (this.available_modules.indexOf(module) == -1) {
        return false;
      } else {
        return true;
      }
    },
    authorizedRole: function(authRole) {
      if (this.role <= authRole) {
        return true;
      }
      return false;
    },
    permittedMediumModules: function(privilege_id, user_id) {
      // Medium Module code
      // Quản lí dịch vụ: service
      //    Dịch vụ: service_service
      // Quản lí người dùng: user
      //    Nhân viên: user_staff
      //    Khách hàng: user_customer
      // Quản lí tài sản: asset
      //    Thiết Bị Đo: asset_meter
      //    Tài Sản: asset_asset
      // Quản lí BDS: bds
      //    BĐS: bds_bds
      // Quản lí căn hộ: apartment
      //    Căn hộ: apartment_apartment
      // Quản lí lease back: leaseback
      //    Lease back: leaseback_leaseback
      // Quản lí phản hồi: case
      //    Case: case_case
      //    Nguyên Tắc: case_escalation_process
      //    Cấp: case_escalation_stage
      // Quản lí giao diện: gui
      //    Giao diện: gui_gui
      // Quản lí phân quyền: permission
      //    Phân Quyền: permission_permission
      // Quản lí thanh toán: payment
      //    Thanh Toán: payment_payment
      // Quản lí báo cáo: report
      //    Dịch Vụ: report_service
      //    Hóa Đơn: report_invoice
      //    Công nợ: report_liabilities
      // Quản lí mua sắm: shop
      //    Mua Sắm: shop_shop
      // Quản lí hóa đơn/phiếu báo: invoice
      //    Hóa Đơn: invoice_invoice
      // HDSD: document
      //    HDSD: document_document
      // Cài đặt dự án:
      //    QLPB: Phiên bản Mobile
      let full_sub_modules = [
        "bds_contract",
        "project_rewardpoint",
        "advertise_advertise",
        "bds_scheduleprogress",
        "bds_bds",
        "service_service",
        "user_staff",
        "user_customer",
        "asset_meter",
        "asset_asset",
        "bds_bds",
        "apartment_apartment",
        "leaseback_leaseback",
        "case_case",
        "case_escalation_process",
        "case_escalation_stage",
        "gui_gui",
        "permission_permission",
        "payment_payment",
        "report_service",
        "report_invoice",
        "report_liabilities",
        "shop_shop",
        "invoice_invoice",
        "document_document",
        // "decentralization_decentralizationUser",
        "project_decentralizationUser",
        "project_mobile",
        "leaseback_apartment_reservation",
        "report_accountinghomeliability",
        "report_accounting_home_liability_detail",
        "invoice_receipt_customer",
        "service_package",
        "report_incurred_liabilitities_report",
        "case_send_notification",
        "apartment_report",
        "service_coupon",
        "invoice_receipt_list",
        "invoice_e_invoice_list",
        "case_to_do_list",
        "project_customizationtable_smtp",
        "case_form_email_list",
        "banner_banner",
        "project_config_template_notification",
        "news_resident",
        "news_news",
        "news_categories",
        "apartment_register_export_invoice",
        "asset_maintenance"
        // "apartment_apartment_type"
      ];
      // Accounting sub modules
      let accounting_sub_modules = [
        "report_service",
        "report_invoice",
        "leaseback_leaseback",
        "leaseback_apartment_reservation",
        "case_to_do_list"
      ];
      let owner_sub_projects = [];
      // Reception sub modules
      let reception_sub_modules = ["report_invoice", "case_to_do_list"];
      // Technician sub modules
      let technician_sub_modules = ["report_invoice", "case_to_do_list"];
      // Admin sub modules
      let admin_sub_modules = [
        "leaseback_leaseback",
        "gui_gui",
        "permission_permission",
        "payment_payment",
        "report_service",
        "report_invoice",
        "shop_shop",
        "document_document",
        // "decentralization_decentralizationUser",
        "project_decentralizationUser",
        "leaseback_apartment_reservation",
        "case_to_do_list",
        // "banner_banner",
        // "news_resident",
        // "news_news",
        // "news_categories"
      ];
      // Operator sub modules
      let operator_sub_modules = [
        "leaseback_leaseback",
        "gui_gui",
        "payment_payment",
        "report_service",
        "report_invoice",
        "shop_shop",
        "document_document",
        "leaseback_apartment_reservation",
        "case_to_do_list"
      ];
      /**
       * START INVOICE
       * Receipt customer
       * Receipt list
       * Invoice list
       * Bkav Invoice list
       */

      if (this.has_perm("view_apartment_realestate")) {
        accounting_sub_modules.push("bds_bds");
        reception_sub_modules.push("bds_bds");
        owner_sub_projects.push("bds_bds");
        admin_sub_modules.push("bds_bds");
        operator_sub_modules.push("bds_bds");
        technician_sub_modules.push("bds_bds");
      }

      if (this.has_perm("view_apartment_contract")) {
        accounting_sub_modules.push("bds_contract");
        reception_sub_modules.push("bds_contract");
        admin_sub_modules.push("bds_contract");
        owner_sub_projects.push("bds_contract");
        operator_sub_modules.push("bds_contract");
        technician_sub_modules.push("bds_contract");
      }

      if (this.has_perm("view_project_setting")) {
        accounting_sub_modules.push("project_rewardpoint");
        reception_sub_modules.push("project_rewardpoint");
        admin_sub_modules.push("project_rewardpoint");
        owner_sub_projects.push("project_rewardpoint");
        operator_sub_modules.push("project_rewardpoint");
        technician_sub_modules.push("project_rewardpoint");
      }

      if (this.has_perm("view_apartment_schedule_progress")) {
        accounting_sub_modules.push("bds_scheduleprogress");
        reception_sub_modules.push("bds_scheduleprogress");
        owner_sub_projects.push("bds_scheduleprogress");
        admin_sub_modules.push("bds_scheduleprogress");
        operator_sub_modules.push("bds_scheduleprogress");
        technician_sub_modules.push("bds_scheduleprogress");
      }

      if (this.has_perm("view_email_template")) {
        accounting_sub_modules.push("project_config_template_notification");
        reception_sub_modules.push("project_config_template_notification");
        owner_sub_projects.push("project_config_template_notification");
        admin_sub_modules.push("project_config_template_notification");
        operator_sub_modules.push("project_config_template_notification");
        technician_sub_modules.push("project_config_template_notification");
      }

      if (this.has_perm("view_liabilities_list")) {
        accounting_sub_modules.push("report_accountinghomeliability");
        reception_sub_modules.push("report_accountinghomeliability");
        owner_sub_projects.push("report_accountinghomeliability");
        admin_sub_modules.push("report_accountinghomeliability");
        operator_sub_modules.push("report_accountinghomeliability");
        technician_sub_modules.push("report_accountinghomeliability");
      }
      if (this.has_perm("view_receipt_customer")) {
        accounting_sub_modules.push("invoice_receipt_customer");
        reception_sub_modules.push("invoice_receipt_customer");
        admin_sub_modules.push("invoice_receipt_customer");
        owner_sub_projects.push("invoice_receipt_customer");
        operator_sub_modules.push("invoice_receipt_customer");
        technician_sub_modules.push("invoice_receipt_customer");
      }
      if (this.has_perm("view_invoice")) {
        accounting_sub_modules.push("invoice_invoice");
        reception_sub_modules.push("invoice_invoice");
        admin_sub_modules.push("invoice_invoice");
        owner_sub_projects.push("invoice_invoice");
        operator_sub_modules.push("invoice_invoice");
        technician_sub_modules.push("invoice_invoice");
      }
      if (this.has_perm("view_electronic_invoice_list")) {
        accounting_sub_modules.push("invoice_e_invoice_list");
        reception_sub_modules.push("invoice_e_invoice_list");
        admin_sub_modules.push("invoice_e_invoice_list");
        owner_sub_projects.push("invoice_e_invoice_list");
        operator_sub_modules.push("invoice_e_invoice_list");
        technician_sub_modules.push("invoice_e_invoice_list");
      }
      if (this.has_perm("view_receipt_and_confirm")) {
        accounting_sub_modules.push("invoice_receipt_list");
        reception_sub_modules.push("invoice_receipt_list");
        admin_sub_modules.push("invoice_receipt_list");
        owner_sub_projects.push("invoice_receipt_list");
        operator_sub_modules.push("invoice_receipt_list");
        technician_sub_modules.push("invoice_receipt_list");
      }
      /** END INVOICE */

      /**
       * START ASSET
       * Asset
       * Property
       */
      if (this.has_perm("view_asset")) {
        accounting_sub_modules.push("asset_asset");
        reception_sub_modules.push("asset_asset");
        admin_sub_modules.push("asset_asset");
        owner_sub_projects.push("asset_asset");
        operator_sub_modules.push("asset_asset");
        technician_sub_modules.push("asset_asset");
      }
      if (this.has_perm("view_property")) {
        accounting_sub_modules.push("asset_meter");
        reception_sub_modules.push("asset_meter");
        admin_sub_modules.push("asset_meter");
        owner_sub_projects.push("asset_meter");
        operator_sub_modules.push("asset_meter");
        technician_sub_modules.push("asset_meter");
      }
      /**END ASSET */

      /**
       * START SERVICE
       * Service
       * Service package
       * Service coupon */
      if (this.has_perm("view_service_package")) {
        accounting_sub_modules.push("service_package");
        reception_sub_modules.push("service_package");
        admin_sub_modules.push("service_package");
        operator_sub_modules.push("service_package");
        technician_sub_modules.push("service_package");
        owner_sub_projects.push("service_package");
      }
      if (this.has_perm("view_service")) {
        accounting_sub_modules.push("service_service");
        reception_sub_modules.push("service_service");
        admin_sub_modules.push("service_service");
        operator_sub_modules.push("service_service");
        technician_sub_modules.push("service_service");
        owner_sub_projects.push("service_service");
      }
      if (this.has_perm("view_service_coupon")) {
        accounting_sub_modules.push("service_coupon");
        reception_sub_modules.push("service_coupon");
        admin_sub_modules.push("service_coupon");
        operator_sub_modules.push("service_coupon");
        technician_sub_modules.push("service_coupon");
        owner_sub_projects.push("service_coupon");
      }
      /** END SERVICE */

      /**
       * START USER
       * Staff
       * User */
      if (this.has_perm("view_staff")) {
        accounting_sub_modules.push("user_staff");
        reception_sub_modules.push("user_staff");
        admin_sub_modules.push("user_staff");
        operator_sub_modules.push("user_staff");
        technician_sub_modules.push("user_staff");
        owner_sub_projects.push("user_staff");
      }
      if (this.has_perm("view_customer")) {
        accounting_sub_modules.push("user_customer");
        reception_sub_modules.push("user_customer");
        admin_sub_modules.push("user_customer");
        operator_sub_modules.push("user_customer");
        technician_sub_modules.push("user_customer");
        owner_sub_projects.push("user_customer");
      }
      /** END USER */

      /**
       * START LIABILITIES REPORT
       * Liabilities report
       * Incurred liabilities report
       */
      if (this.has_perm("view_liabilitities_report")) {
        accounting_sub_modules.push("report_liabilities");
        reception_sub_modules.push("report_liabilities");
        admin_sub_modules.push("report_liabilities");
        operator_sub_modules.push("report_liabilities");
        technician_sub_modules.push("report_liabilities");
        owner_sub_projects.push("report_liabilities");
      }
      if (this.has_perm("view_incurred_liabilitities_report")) {
        accounting_sub_modules.push("report_incurred_liabilitities_report");
        reception_sub_modules.push("report_incurred_liabilitities_report");
        admin_sub_modules.push("report_incurred_liabilitities_report");
        operator_sub_modules.push("report_incurred_liabilitities_report");
        technician_sub_modules.push("report_incurred_liabilitities_report");
        owner_sub_projects.push("report_incurred_liabilitities_report");
      }
      /**
       * END LIABILITIES REPORT
       */

      /**
       * START CASE
       * View send notification
       * Escalation Process
       * Escalation Stage
       * Case list
       */
      if (this.has_perm("view_send_notification")) {
        accounting_sub_modules.push("case_send_notification");
        reception_sub_modules.push("case_send_notification");
        admin_sub_modules.push("case_send_notification");
        operator_sub_modules.push("case_send_notification");
        technician_sub_modules.push("case_send_notification");
        owner_sub_projects.push("case_send_notification");
      }
      if (this.has_perm("view_advertise")) {
        accounting_sub_modules.push("advertise_advertise");
        reception_sub_modules.push("advertise_advertise");
        admin_sub_modules.push("advertise_advertise");
        operator_sub_modules.push("advertise_advertise");
        technician_sub_modules.push("advertise_advertise");
        owner_sub_projects.push("advertise_advertise");
      }
      if (this.has_perm("view_case_escalation_process")) {
        accounting_sub_modules.push("case_escalation_process");
        reception_sub_modules.push("case_escalation_process");
        admin_sub_modules.push("case_escalation_process");
        operator_sub_modules.push("case_escalation_process");
        technician_sub_modules.push("case_escalation_process");
        owner_sub_projects.push("case_escalation_process");
      }
      if (this.has_perm("view_case_escalation_stage")) {
        accounting_sub_modules.push("case_escalation_stage");
        reception_sub_modules.push("case_escalation_stage");
        admin_sub_modules.push("case_escalation_stage");
        operator_sub_modules.push("case_escalation_stage");
        technician_sub_modules.push("case_escalation_stage");
        owner_sub_projects.push("case_escalation_stage");
      }
      if (this.has_perm("view_case")) {
        accounting_sub_modules.push("case_case");
        reception_sub_modules.push("case_case");
        admin_sub_modules.push("case_case");
        operator_sub_modules.push("case_case");
        technician_sub_modules.push("case_case");
        owner_sub_projects.push("case_case");
      }
      /**
       * END CASE
       */

      /**
       * START APARTMENT
       * Apartment list
       * Apartment report monthly
       */
      if (this.has_perm("view_apartment")) {
        accounting_sub_modules.push("apartment_apartment");
        reception_sub_modules.push("apartment_apartment");
        admin_sub_modules.push("apartment_apartment");
        operator_sub_modules.push("apartment_apartment");
        technician_sub_modules.push("apartment_apartment");
        owner_sub_projects.push("apartment_apartment");
        //super_admin_sub_modules.push("apartment_apartment");
      }
      if (this.has_perm("view_apartment_report")) {
        accounting_sub_modules.push("apartment_report");
        reception_sub_modules.push("apartment_report");
        admin_sub_modules.push("apartment_report");
        operator_sub_modules.push("apartment_report");
        technician_sub_modules.push("apartment_report");
        owner_sub_projects.push("apartment_report");
        //super_admin_sub_modules.push("apartment_report");
      }

      if (this.has_perm('view_register_export_invoice')) {
        accounting_sub_modules.push("apartment_register_export_invoice");
        reception_sub_modules.push("apartment_register_export_invoice");
        admin_sub_modules.push("apartment_register_export_invoice");
        operator_sub_modules.push("apartment_register_export_invoice");
        technician_sub_modules.push("apartment_register_export_invoice");
        owner_sub_projects.push("apartment_register_export_invoice");
      }

      if (this.has_perm('view_banner')) {
        accounting_sub_modules.push("banner_banner");
        reception_sub_modules.push("banner_banner");
        admin_sub_modules.push("banner_banner");
        operator_sub_modules.push("banner_banner");
        technician_sub_modules.push("banner_banner");
        owner_sub_projects.push("banner_banner");
      }

      // management news
      if (this.has_perm('view_resident_news_board')) {
        accounting_sub_modules.push("news_resident");
        reception_sub_modules.push("news_resident");
        admin_sub_modules.push("news_resident");
        operator_sub_modules.push("news_resident");
        technician_sub_modules.push("news_resident");
        owner_sub_projects.push("news_resident");
      }

      if (this.has_perm('view_news')) {
        accounting_sub_modules.push("news_news");
        reception_sub_modules.push("news_news");
        admin_sub_modules.push("news_news");
        operator_sub_modules.push("news_news");
        technician_sub_modules.push("news_news");
        owner_sub_projects.push("news_news");
      }

      if (this.has_perm('view_news_categories')) {
        accounting_sub_modules.push("news_categories");
        reception_sub_modules.push("news_categories");
        admin_sub_modules.push("news_categories");
        operator_sub_modules.push("news_categories");
        technician_sub_modules.push("news_categories");
        owner_sub_projects.push("news_categories");
      }

      // if (this.has_perm('view_maintenance')) {
      //   accounting_sub_modules.push("asset_maintenance");
      //   reception_sub_modules.push("asset_maintenance");
      //   admin_sub_modules.push("asset_maintenance");
      //   operator_sub_modules.push("asset_maintenance");
      //   technician_sub_modules.push("asset_maintenance");
      //   owner_sub_projects.push("asset_maintenance");
      // }
      /**
       * END APARTMENT
       */
      // if (user_id == 1 || user_id == 2) {
      //   return full_sub_modules;
      // } else if (this.superAdmin == 1) {
      //   return full_sub_modules;
      if (user_id == 1 || user_id == 2) {
        return full_sub_modules.concat(this.getModuleConfigEnable());
      } else if (this.superAdmin == 1) {
        return full_sub_modules.concat(this.getModuleConfigEnable());
      } else if (privilege_id == 1) {
        return owner_sub_projects.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      } else if (privilege_id == 2) {
        // old 1
        return admin_sub_modules.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      } else if (privilege_id == 7) {
        // old 4
        return [];
      } else if (privilege_id == 8) {
        // old 5
        return [];
      } else if (privilege_id == 3) {
        // old 6
        return operator_sub_modules.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      } else if (privilege_id == 4) {
        // old 7
        return technician_sub_modules.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      } else if (privilege_id == 5) {
        // old 8
        return accounting_sub_modules.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      } else if (privilege_id == 6) {
        // old 9
        return reception_sub_modules.concat(this.getModuleConfigEnable(), this.getAdminSystemSubModule());
      }
    },
    permittedLargeModules: function(privilege_id, user_id) {
      // Large Module code
      // xxxMobile App: mobile
      // xxxEmail, SMS: email
      // Quản lí dịch vụ: service
      // Quản lí người dùng: user
      // Quản lí tài sản: asset
      // Quản lí BDS: bds
      // Quản lí căn hộ: apartment
      // Quản lí lease back: leaseback
      // Quản lí phản hồi: case
      // Quản lí giao diện: gui
      // Quản lí phân quyền: permission
      // Quản lí thanh toán: payment
      // Quản lí báo cáo: report
      // Quản lí mua sắm: shop
      // Quản lí hóa đơn/phiếu báo: invoice
      // HDSD: document
      // let full_modules = [
      //   "dashboard",
      //   "search",
      //   "advertise",
      //   "bds",
      //   "gui",
      //   "permission",
      //   "payment",
      //   "shop",
      //   "document",
      //   "decentralization",
      //   "project",
      //   "case",
      //   "invoice",
      //   "asset",
      //   "apartment",
      //   "service",
      //   "user",
      //   "leaseback",
      //   "report",
      // ];

      let superadminModule = []
      let owner_projects = [];
      // let admin_modules = ['gui', 'permission', 'payment', 'shop', 'document', 'decentralization']
      let admin_modules = [];
      // Accounting modules
      let accounting_modules = [];
      // Operator modules
      // let operator_modules = ['gui', 'payment', 'shop', 'document']
      let operator_modules = [];
      // Reception modules
      let reception_modules = [];
      // Techinician modules
      let technician_modules = [];
      // decentralization
      if (this.is_check_has("decentralization")) {
        admin_modules.push("decentralization");
        owner_projects.push("decentralization");
        accounting_modules.push("decentralization");
        operator_modules.push("decentralization");
        reception_modules.push("decentralization");
        technician_modules.push("decentralization");
      }
      // document
      if (this.is_check_has("document")) {
        admin_modules.push("document");
        accounting_modules.push("document");
        operator_modules.push("document");
        owner_projects.push("document");
        reception_modules.push("document");
        technician_modules.push("document");
      }
      //search
      if (this.is_check_has("search")) {
        admin_modules.push("search");
        accounting_modules.push("search");
        operator_modules.push("search");
        owner_projects.push("search");
        reception_modules.push("search");
        technician_modules.push("search");
      }
      //dashboard
      if (this.is_check_has("dashboard")) {
        admin_modules.push("dashboard");
        accounting_modules.push("dashboard");
        operator_modules.push("dashboard");
        owner_projects.push("dashboard");
        reception_modules.push("dashboard");
        technician_modules.push("dashboard");
      }
      // Project
      if (
        this.has_perm("view_project_setting") &&
        this.is_check_has("project")
      ) {
        admin_modules.push("project");
        accounting_modules.push("project");
        operator_modules.push("project");
        owner_projects.push("project");
        reception_modules.push("project");
        technician_modules.push("project");
      }
      // Advertise
      if (this.has_perm("view_advertise") && this.is_check_has("advertise")) {
        admin_modules.push("advertise");
        accounting_modules.push("advertise");
        operator_modules.push("advertise");
        owner_projects.push("advertise");
        reception_modules.push("advertise");
        technician_modules.push("advertise");
      }
      // Case
      if (
        (this.has_perm("view_case") ||
          this.has_perm("view_case_escalation_stage") ||
          this.has_perm("view_case_escalation_process") ||
          this.has_perm("view_send_notification")) &&
        this.is_check_has("case")
      ) {
        admin_modules.push("case");
        accounting_modules.push("case");
        owner_projects.push("case");
        operator_modules.push("case");
        reception_modules.push("case");
        technician_modules.push("case");
      }

      // Invoice
      if (
        (this.has_perm("view_invoice") ||
          this.has_perm("view_receipt_and_confirm") ||
          this.has_perm("view_electronic_invoice_list") ||
          this.has_perm("view_receipt_customer")) &&
        this.is_check_has("invoice")
      ) {
        admin_modules.push("invoice");
        accounting_modules.push("invoice");
        operator_modules.push("invoice");
        reception_modules.push("invoice");
        owner_projects.push("invoice");
        technician_modules.push("invoice");
      }
      // Asset
      if (
        (this.has_perm("view_asset") || this.has_perm("view_property")) &&
        this.is_check_has("asset")
      ) {
        admin_modules.push("asset");
        accounting_modules.push("asset");
        operator_modules.push("asset");
        owner_projects.push("asset");
        reception_modules.push("asset");
        technician_modules.push("asset");
      }
      // Apartment
      if (
        (this.has_perm("view_apartment") ||
          this.has_perm("view_apartment_report")) &&
        this.is_check_has("apartment")
      ) {
        admin_modules.push("apartment");
        accounting_modules.push("apartment");
        operator_modules.push("apartment");
        owner_projects.push("apartment");
        reception_modules.push("apartment");
        technician_modules.push("apartment");
      }
      // Apartment Realestate
      if (
        (this.has_perm("view_apartment_schedule_progress") ||
          this.has_perm("view_apartment_realestate")) &&
        this.is_check_has("bds")
      ) {
        admin_modules.push("bds");
        accounting_modules.push("bds");
        operator_modules.push("bds");
        owner_projects.push("bds");
        reception_modules.push("bds");
        technician_modules.push("bds");
      }
      // Service
      if (
        (this.has_perm("view_service_package") ||
          this.has_perm("view_service")) &&
        this.is_check_has("service")
      ) {
        admin_modules.push("service");
        accounting_modules.push("service");
        operator_modules.push("service");
        owner_projects.push("service");
        reception_modules.push("service");
        technician_modules.push("service");
      }
      // User
      if (
        (this.has_perm("view_staff") || this.has_perm("view_customer")) &&
        this.is_check_has("user")
      ) {
        admin_modules.push("user");
        accounting_modules.push("user");
        operator_modules.push("user");
        owner_projects.push("user");
        reception_modules.push("user");
        technician_modules.push("user");
      }
      // LeaseBack
      if (this.has_perm("view_lease_back") && this.is_check_has("leaseback")) {
        admin_modules.push("leaseback");
        accounting_modules.push("leaseback");
        operator_modules.push("leaseback");
        owner_projects.push("leaseback");
        reception_modules.push("leaseback");
        technician_modules.push("leaseback");
      }
      // Liabilities and incurred liabilities report
      if (
        (this.has_perm("view_liabilitities_report") ||
          this.has_perm("view_liabilities_list") ||
          this.has_perm("view_incurred_liabilitities_report")) &&
        this.is_check_has("report")
      ) {
        admin_modules.push("report");
        reception_modules.push("report");
        owner_projects.push("report");
        accounting_modules.push("report");
        operator_modules.push("report");
        technician_modules.push("report");
      }
      if (this.has_perm("view_banner")) {
        admin_modules.push("banner");
        accounting_modules.push("banner");
        operator_modules.push("banner");
        owner_projects.push("banner");
        reception_modules.push("banner");
        technician_modules.push("banner");
      }
      if (this.has_perm("view_resident_news_board")||
        this.has_perm("view_news")||
        this.has_perm("view_news_categories")
      ) {
        admin_modules.push("news");
        accounting_modules.push("news");
        operator_modules.push("news");
        owner_projects.push("news");
        reception_modules.push("news");
        technician_modules.push("news");
      }
      if (this.has_perm("view_maintenance") && utils.getProjectSession()) {
        admin_modules.push("maintenance");
        accounting_modules.push("maintenance");
        operator_modules.push("maintenance");
        owner_projects.push("maintenance");
        reception_modules.push("maintenance");
        technician_modules.push("maintenance");
        superadminModule.push("maintenance")
      }
      // if (user_id == 1 || user_id == 2) {
      //   return full_modules;
      let largeModuleProject = this.is_check_has("project") === false &&
        utils.getProjectSession() ? ["project"] : []
      let superadmin_module = this.available_modules.concat(this.getLargeModuleConfigEnable(), superadminModule)
      if (user_id == 1 || user_id == 2) {
        return superadmin_module.concat(largeModuleProject);
      } else if (privilege_id == 2) {
        // admin // old 1
        return admin_modules.concat(this.getLargeModuleConfigEnable(), largeModuleProject);
      } else if (privilege_id == 1) {
        // owner_project
        return owner_projects.concat(this.getLargeModuleConfigEnable());
      } else if (privilege_id == 7) {
        // customer - normal // old 4
        return [];
      } else if (privilege_id == 8) {
        // customer - guest // old 5
        return [];
      } else if (privilege_id == 3) {
        // operator // old 6
        return operator_modules.concat(this.getLargeModuleConfigEnable());
      } else if (privilege_id == 4) {
        // technician // old 7
        return technician_modules.concat(this.getLargeModuleConfigEnable());
      } else if (privilege_id == 5) {
        // accounting // old 8
        return accounting_modules.concat(this.getLargeModuleConfigEnable());
      } else if (privilege_id == 6) {
        // reception // old 9
        return reception_modules.concat(this.getLargeModuleConfigEnable());
      }

      return [];
    },
    getModuleConfigEnable: function(){
      let results = []
      let data = this.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.module_array !== undefined
        ? this.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.module_array : []
      if (this.has_perm("view_apartment") && data.includes('apartment_apartment_type')) {
        results.push('apartment_apartment_type')
      }
      if (data.includes('service_product') && this.has_perm('view_product')) {
        results.push('service_product')
      }
      if (data.includes('product_and_service_in_apartment')) {
        results.push('apartment_product_and_service')
      }
      if (data.includes('apartment_diagram')) {
        results.push('apartment_apartment_diagram')
      }
      if (data.includes('management_booking')) {
        results.push('apartment_apartment_booking')
      }
      if (data.includes('management_service_order') && this.has_perm('view_service_order')) {
        results.push('service_management_service_order')
      }
      if (data.includes('apartment_receipt') && this.has_perm('view_apartment_receipt')) {
        results.push('report_apartment_receipt', 'apartment_room_bill')
      }
      if (data.includes('room_performance_report') && this.has_perm('view_room_performance_report')) {
        results.push('report_room_performance_report')
      }
      if (data.includes('event_management') && this.has_perm('view_event_management')) {
        results.push('news_event_management')
      }
      if (data.includes('home_mobile_management') && this.has_perm("view_home_mobile")) {
        results.push('news_home_mobile_management')
      }
      if (data.includes('frequently_asked_questions') && this.has_perm("view_frequently_asked_questions")) {
        results.push('news_frequently_asked_questions')
      }
      if (data.includes('approval_apartment_resident') && this.has_perm("view_approval_apartment_resident")) {
        results.push('apartment_approval_apartment_resident')
      }
      if (data.includes('apartment_group') && this.has_perm("view_apartment_group")) {
        results.push('apartment_apartmentGroup')
      }
      return results
    },
    getLargeModuleConfigEnable: function() {
      let results = []
      // let data = this.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.module_array !== undefined
      //   ? this.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.module_array : []
      // if (data.includes('home_mobile_management') && this.has_perm("view_home_mobile")) {
      //   results.push('home_mobile_management')
      // }
      return results
    },
    getAdminSystemSubModule: function() {
      let arrayResult = []
      if(this.isAdmin()) {
        arrayResult.push("project_customizationtable_smtp")
      }
      return arrayResult
    }
  },
  components: {
    "va-slide-item": VASlideItem
  },
  async mounted() {
    let projectId = utils.getProjectSession()
    if (projectId) {
      await this.GET_AVAILABLE_MODULE({ id: projectId });
    }
  }
};
</script>
<style scoped>
.disabled {
  pointer-events: none;
  mix-blend-mode: soft-light;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/SideBar.vue